// extracted by mini-css-extract-plugin
export default {"warpper":"App_warpper__aaHHc","content":"App_content__WcBYa"};